<template>
  <v-dialog v-model="visible" max-width="1000px" persistent>
    <v-card>
      <v-card-title>
        {{ $t('message.common.imagedraw') }}
      </v-card-title>

      <v-card-text>
        <div ref="editor" style="height:600px;width:100%;"></div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn class="vue-co-btn new-btn" @click="saveImage" :loading="imageEditorloading">
          {{ $t('message.common.save') }}
        </v-btn>

        <v-btn class="vue-co-btn new-btn" @click="close">
          {{ $t('message.common.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { checklistApi } from '@/plugins/axios_settings'
import ImageEditor from 'tui-image-editor'
import 'tui-image-editor/dist/tui-image-editor.css'
import 'tui-color-picker/dist/tui-color-picker.css'

// ✅ import icons (IMPORTANT)
import iconA from 'tui-image-editor/dist/svg/icon-a.svg'
import iconB from 'tui-image-editor/dist/svg/icon-b.svg'
import iconC from 'tui-image-editor/dist/svg/icon-c.svg'
import iconD from 'tui-image-editor/dist/svg/icon-d.svg'

// ✅ define theme OUTSIDE component
const whiteTheme = {
  'common.backgroundColor': '#fff',
  'common.border': '1px solid #c1c1c1',

  'menu.normalIcon.path': iconD,
  'menu.normalIcon.name': 'icon-d',
  'menu.activeIcon.path': iconB,
  'menu.activeIcon.name': 'icon-b',
  'menu.disabledIcon.path': iconA,
  'menu.disabledIcon.name': 'icon-a',
  'menu.hoverIcon.path': iconC,
  'menu.hoverIcon.name': 'icon-c',

  'submenu.normalIcon.path': iconD,
  'submenu.normalIcon.name': 'icon-d',
  'submenu.activeIcon.path': iconB,
  'submenu.activeIcon.name': 'icon-b',
  'header.display': 'none',
  'submenu.backgroundColor': 'transparent',

  'range.pointer.color': '#333',
  'range.bar.color': '#ccc',
  'range.subbar.color': '#606060',
  'range.disabledPointer.color': '#d3d3d3',
  'range.disabledBar.color': 'rgba(85,85,85,0.06)',
  'range.disabledSubbar.color': 'rgba(51,51,51,0.2)',
  'range.value.color': '#000',
  'range.value.fontWeight': 'normal',
  'range.value.fontSize': '11px',
  'range.value.border': '0',
  'range.value.backgroundColor': '#f5f5f5',
  'range.title.color': '#000',
  'range.title.fontWeight': 'lighter'
}

export default {
  name: 'ImageEditorDialog',

  props: {
    value: Boolean,
    document: Object
  },

  data () {
    return {
      visible: false,
      editor: null,
      imageEditorloading: false
    }
  },

  watch: {
    value (val) {
      this.visible = val
      if (val) {
        this.$nextTick(() => {
          this.initEditor()
        })
      }
    }
  },

  methods: {
    initEditor () {
      if (!this.$refs.editor || !this.document) return

      if (this.editor) {
        this.editor.destroy()
        this.editor = null
      }

      this.editor = new ImageEditor(this.$refs.editor, {
        includeUI: {
          loadImage: {
            path: this.document?.imgObj?.url,
            name: this.document?.file_original_name
          },
          theme: whiteTheme,
          menu: ['crop', 'flip', 'rotate', 'draw', 'shape', 'icon', 'text'],
          initMenu: 'draw',
          menuBarPosition: 'bottom'
        },
        selectionStyle: {
          cornerSize: 50,
          rotatingPointOffset: 100
        },
        cssMaxWidth: 700,
        cssMaxHeight: 500,
        usageStatistics: false
      })

      this.$nextTick(() => {
        if (this.editor && this.editor.ui) {
          this.editor.ui.resizeEditor()
        }
      })
    },

    dataURLtoBlob (dataurl) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }

      return new Blob([u8arr], { type: mime })
    },

    saveImage () {
      if (!this.editor || !this.document?._id) return

      this.imageEditorloading = true

      const editedImage = this.editor.toDataURL()
      const blob = this.dataURLtoBlob(editedImage)

      const formData = new FormData()
      formData.append('file', blob, 'edited-image.png')
      checklistApi.post(`documents/update_attachment/${this.document._id}`, formData)
        .then((res) => {
          if (res.data) {
            this.imageEditorloading = false
            this.$emit('save', editedImage)
            this.close()
          }
        })
        .catch(() => {
          this.imageEditorloading = false
        })
    },

    close () {
      this.visible = false

      if (this.editor) {
        this.editor.destroy()
        this.editor = null
      }

      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>
    .tui-image-editor-container {
        border: 1px solid #ddd;
    }
    .tui-image-editor-container svg {
        fill: #fff;
    }
    .tui-image-editor-container{
        min-height: 700px !important;
        min-width: 550px !important
    }
    .v-card{
      min-width: 600px !important;
      background-color: #fff !important;
    }
</style>
